const global = window

// Copie
inputs.behavior.copy = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.copy) {
        if (typeof data.copy == 'string') data.copy = [data.copy]
        $.each(data.copy, function (index, field) {
            inputWindow.find('[data-id="' + field + '"]').change(function () {
                let change = true
                let newVal = []
                $.each(data.copy, function (index, field) {
                    field = inputWindow.find('[data-id="' + field + '"]')
                    const fieldData = field.data('data')
                    if (field.val() !== null && field.val() !== undefined && String(field.val()).trim()) {
                        let newValSegment = String((field.val() || "")).trim()
                        switch (fieldData ? fieldData.type : '') {
	                        case 'coordinate':
	                            const inputName = input.attr('name').toLowerCase()
	                            if (
                                    left(inputName, 1) == 'x' ||
                                    right(inputName, 1) == 'x'
	                            ) {
	                                newValSegment = newValSegment.split(',')[0]
	                                change = false
	                            } else if (
                                    left(inputName, 1) == 'y' ||
                                    right(inputName, 1) == 'y'
	                            ) {
	                                newValSegment = newValSegment.split(',')[1]
	                                change = false
	                            }
	                            break
	                        case 'cropper':
	                            const inputName2 = input.attr('name').toLowerCase()
	                            const values = newValSegment.split(',')
	                            if (inputName2 == 'x') {
	                                newValSegment = values[0]
	                                change = false
	                            } else if (inputName2 == 'y') {
	                                newValSegment = values[1]
	                                change = false
	                            } else if (inputName2 == 'width') {
	                                newValSegment = values[2]
	                                change = false
	                            } else if (inputName2 == 'height') {
	                                newValSegment = values[3]
	                                change = false
	                            }
	                            break
	                        default:
	                            break;
                        }
                        newVal.push(newValSegment)
                    }
                })

                let separator = ' '
                switch (data.type) {
	                case 'coordinate':
	                    separator = ','
	                    break
	                case 'cropper':
	                    separator = ','
	                    break
	                default:
	                    break;
                }

                newVal = newVal.join(separator).trim()
                if (input.val() != newVal) {
                    input.val(newVal)
                    if (change) input.change()
                }
            })

            inputWindow.find('[data-id="' + field + '"]').keyup(function () {
                $(this).change()
            })
        })
    }
    return data
}
